import { createSlice } from '@reduxjs/toolkit';

const initialState = { collapsed: false };

const sideBarSlice = createSlice({
  name: 'sideBar',
  initialState,
  reducers: {
    setCollapsed: (state, action) => {
      state.collapsed = action.payload;
    },
  },
});

export const { setCollapsed } = sideBarSlice.actions;
export default sideBarSlice.reducer;